import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { POLEnvironmentConstants } from 'src/app/core/constants/pol-environment.constants';
import { Microservices } from 'src/app/core/constants/pol.enums';
import { UmbracoApiResponse } from 'src/app/core/models/global.model';
import { INavigationItem, INavigationFavorite, INavigationChildItem } from './state/navigation.model';
import { Helpers } from 'src/app/utils/helpers';
import { Router } from '@angular/router';

@Injectable()
export class NavigationService {
  router = inject(Router);
  environment: string;

  constructor(private http: HttpClient) {
    this.environment = POLEnvironmentConstants.env;
  }

  getNavigationItems(): Observable<INavigationItem[]> {
    const apiUrl = `${Microservices.UmbracoCMS}/navigation/id?id=c098bd70-4e1e-4a52-afd9-0c47abf29ab4`;
    const sort = (a: INavigationItem, b: INavigationItem) => {
      return Number(a?.menuData?.menuSortOrder) - Number(b?.menuData?.menuSortOrder);
    }
    const menuChildrenSort = (a: INavigationChildItem, b: INavigationChildItem) => {
      return Number(a?.linkSortOrder) - Number(b?.linkSortOrder);
    }

    return this.http.get<UmbracoApiResponse<INavigationItem[]>>(apiUrl).pipe(
      map((response: UmbracoApiResponse<INavigationItem[]>) => {
        response.contents.sort(sort);
        response.contents.forEach(res=>res.menuChildren.sort(menuChildrenSort));
        return response.contents;
      }),
      catchError(async () => {
        const data = await Helpers.getDataFromServiceWorkerCache<UmbracoApiResponse<INavigationItem[]>>('umbraco-navigation-cache', apiUrl);

        if(data) {
          data.contents.sort(sort);
          data.contents.forEach(res=>res.menuChildren.sort(menuChildrenSort));
          return data.contents;
        } else {
          this.router.navigateByUrl('login-error', { replaceUrl: true });
          return [];
        }
      })
    );
  }

  fetchNavigationFavorites(): Observable<INavigationFavorite[]> {
    const apiUrl = `${Microservices.ProviderOnline}/NavigationFavorites`;
    return this.http.get<{ favorites: string[] }>(apiUrl).pipe(
      map(res => res.favorites.map(i => ({ navigationId: i })))
    );
  }

  addNavigationFavorite(payload: INavigationFavorite): Observable<void> {
    const apiUrl = `${Microservices.ProviderOnline}/UserPreferences/NavigationFavorites/Add`;
    return this.http.post<void>(apiUrl, { navigationId: payload.navigationId });
  }

  updateNavigationFavorites(newFavorites: INavigationFavorite[]): Observable<void> {
    const apiUrl = `${Microservices.ProviderOnline}/UserPreferences/NavigationFavorites/Reorder`;
    const payload = {
      navigationFavorites: newFavorites.map((navigationFavorite) => navigationFavorite.navigationId)
    }
    return this.http.put<void>(apiUrl, payload);
  }

  deleteNavigationFavorite(payload: INavigationFavorite): Observable<void> {
    const apiUrl = `${Microservices.ProviderOnline}/UserPreferences/NavigationFavorites/Delete`;
    const options = {
      body: { navigationId: payload.navigationId }
    }
    return this.http.delete<void>(apiUrl, options);
  }

  getFooterContent(){
    const apiUrl = `${Microservices.UmbracoCMS}/ContentData/8315a954-fb34-4d5e-9075-8ee837be41c0`;
    return this.http.get(apiUrl);
  }
}
